declare global {
  interface Window {
    Canny?: CannyFunction;
  }
}

type CannyFunction = {
  (command: 'render', options: CannyRenderOptions): void;
  q: unknown[];
};

interface CannyRenderOptions {
  boardToken: string;
  basePath: string | null;
  ssoToken: string | null;
  theme: 'light' | 'dark' | 'auto';
}

const CANNY_BOARD_TOKEN = '90b90260-3308-8734-d955-24795c341049';

let isLoaded = false;

const loadCannySDK = (): Promise<void> => {
  return new Promise((resolve) => {
    if (isLoaded || window.Canny) {
      resolve();
      return;
    }

    // Initialize Canny queue
    const c = function (...args: unknown[]) {
      c.q.push(args);
    } as CannyFunction;
    c.q = [];
    window.Canny = c;

    // Load SDK script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://sdk.canny.io/sdk.js';
    script.onload = () => {
      isLoaded = true;
      resolve();
    };

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  });
};

export const renderCannyWidget = async (ssoToken?: string | null): Promise<void> => {
  await loadCannySDK();

  if (window.Canny) {
    window.Canny('render', {
      boardToken: CANNY_BOARD_TOKEN,
      basePath: '/feedback',
      ssoToken: ssoToken ?? null,
      theme: 'auto',
    });
  }
};
